import { HubFeature, HubPermission } from '@ats/api/cm';
import { Guard } from '@ats/cm/core';
import gql from 'graphql-tag';

export const CE_PROGRESS_QUERY = gql`
	query continuingEducationProgress($cmcId: CandidateIdRequest, $certRequest: CertListRequest) {
		candidateAccount(request: $cmcId) {
			cmcId
			certList(request: $certRequest) {
				id
				status
				expireDate
				certCatalog {
					id
					name
				}
				continuingEducationProgressList {
					progressList {
						submittedPoints
						requiredPoints
						startDate
						displayStatus
						catalogList {
							name
						}
					}
				}
			}
		}
	}
`;

export const CAND_CRCAT_QUERY = (guard: Guard) => gql`
	query candidateAccount($cmcId: CandidateIdRequest, $types: CertRequirementListRequest) {
		candidateAccount(request: $cmcId) {
			cmcId
			certRequirementList(request: $types) {
				id
				${
					guard
						.reset()
						.everyFeature([HubFeature.CredentialContinuingEducation])
						.everyPermission([
							HubPermission.CandidateRequirementsContinuingEducationView,
						]).all
						? `
						points
						`
						: ''
				}
				certRequirementCatalog {
					id
				}
			}
		}
	}
`;
